import { pascalCase } from './case';

// Auto-requires files.
// See https://vuejs.org/v2/guide/components-registration.html#Automatic-Global-Registration-of-Base-Components
function requireFiles(requireComponent) {
  return requireComponent.keys().map((fileName) => {
    const fileConfig = requireComponent(fileName);

    // Remove file extension.
    const name = fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '');

    return [
      name,
      // Look for the file options on `.default`, which will exist if the file
      // was exported with `export default`, otherwise fall back to module's
      // root.
      fileConfig.default || fileConfig,
    ];
  });
}

function requireComponentishFiles(requireComponent) {
  return requireFiles(requireComponent).map((pair) => [
    pascalCase(pair[0]),
    pair[1],
  ]);
}

export function requireModels() {
  // NOTE: We need to use require.context directly to avoid the following error:
  // Critical dependency: require function is used in a way in which
  // dependencies cannot be statically extracted`
  return requireComponentishFiles(
    require.context('@/models', false, /[A-Z]\w+\.js$/)
  );
}
